import Vue from 'vue'

const initState = {
  // Old Editor
  socialButtonSectionKey: null,
  buttonSectionKey: null,
  buttonId: null,
  activeShadowKey: null,
  hoverBoxKey: null,
  activeBoxKey: null,
  // New Editor
  frontReady: false,
  activeObject: null,
  hoverObject: null,
  activeEditorModal: {
    floating: null,
    default: null
  },
  editorStatus: null,
  resizeData: null,
  listViewStatus: {},
  imageUploadStatus2: {},
  extraProcessingStatus: {},
  extraProcessingStatus2: {},
  instantGalleryUpdate: {},
  device: 'desktop',
  hideSettingsModal: false,
  popupStatus: false,
  integrationsObject: {},
  pages: [],
  files: [],
  blocks: [],
  agencyBlocks: [],
  activeProduct: null,
  timerStartValue: null,
  timerHideItems: []
}

export default {
  namespaced: true,
  state: Vue.util.extend({}, initState),
  mutations: {
    // Old Editor
    SET_SOCIALBUTTONSECTIONKEY(state, value) {
      state.socialButtonSectionKey = value
    },
    SET_BUTTONSECTIONKEY(state, value) {
      state.buttonSectionKey = value
    },
    SET_BUTTONID(state, value) {
      state.buttonId = value
    },
    SET_ACTIVESHADOWKEY(state, value) {
      state.activeShadowKey = value
    },
    SET_HOVERBOXKEY(state, value) {
      state.hoverBoxKey = value
    },
    SET_ACTIVEBOXKEY(state, value) {
      state.activeBoxKey = value
    },
    // New Editor
    SET_FRONTREADY(state, value) {
      state.frontReady = value
    },
    SET_ACTIVEOBJECT(state, value) {
      if (value) state.activeObject = { ...value }
      else state.activeObject = null
    },
    SET_HOVEROBJECT(state, value) {
      if (value) state.hoverObject = { ...value }
      else state.hoverObject = null
    },
    SET_ACTIVEEDITORMODAL(state, value) {
      state.activeEditorModal = { ...value }
    },
    SET_EDITORSTATUS(state, value) {
      state.editorStatus = value
    },
    SET_RESIZEDATA(state, value) {
      if (value) state.resizeData = { ...value }
      else state.resizeData = null
    },
    SET_LISTVIEWSTATUS(state, value) {
      state.listViewStatus = { ...value }
    },
    SET_IMAGEUPLOADSTATUS2(state, value) {
      state.imageUploadStatus2 = { ...value }
    },
    SET_EXTRAPROCESSINGSTATUS(state, value) {
      state.extraProcessingStatus = { ...value }
    },
    SET_EXTRAPROCESSINGSTATUS2(state, value) {
      state.extraProcessingStatus2 = { ...value }
    },
    SET_INSTANTGALLERYUPDATE(state, value) {
      state.instantGalleryUpdate = { ...value }
    },
    SET_DEVICE(state, value) {
      state.device = value
    },
    SET_HIDESETTINGS_MODAL(state, value) {
      state.hideSettingsModal = value
    },
    SET_POPUPSTATUS(state, value) {
      state.popupStatus = value
    },
    SET_INTEGRATIONSOBJECT(state, value) {
      let integrationsObject = {}
      if (value && Array.isArray(value)) {
        value.forEach((item) => {
          integrationsObject = {
            ...integrationsObject,
            [`integration-${item.id}`]: item
          }
        })
      }
      state.integrationsObject = integrationsObject
    },
    SET_PAGES(state, value) {
      const items = value.pages || []
      const newItems = []
      if (items && items.length) {
        items.forEach((item) => {
          newItems.push({
            unique_name: item.unique_name,
            name: item.name
          })
        })
      }
      if (value.hasPublishedBlog) {
        newItems.push({ unique_name: 'blog', name: 'Blog' })
      }
      if (value.hasPublishedEpisode) {
        newItems.push({ unique_name: 'episodes', name: 'Episodes' })
      }
      state.pages = newItems
    },
    SET_FILES(state, value) {
      const items = value.files || []
      const newItems = []
      if (items && items.length) {
        items.forEach((item) => {
          newItems.push(item)
        })
      }
      state.files = newItems
    },
    SET_BLOCKS(state, value) {
      state.blocks = value
    },
    SET_AGENCYBLOCKS(state, value) {
      state.agencyBlocks = value
    },
    SET_ACTIVEPRODUCT(state, value) {
      state.activeProduct = value
    },
    SET_TIMERSTARTVALUE(state, value) {
      state.timerStartValue = value
    },
    SET_TIMERHIDEITEMS(state, value) {
      state.timerHideItems = value
    },
    INIT_NE_VALUES(state) {
      state.activeObject = null
      state.hoverObject = null
      state.activeEditorModal = {
        floating: null,
        default: null
      }
      state.editorStatus = null
      state.resizeData = null
      state.listViewStatus = {}
      state.imageUploadStatus2 = {}
      state.extraProcessingStatus = {}
      state.instantGalleryUpdate = {}
      state.device = 'desktop'
      state.hideSettingsModal = false
      state.integrationsObject = {}
      state.pages = []
      state.blocks = []
      state.agencyBlocks = []
    },
    INIT_NE_FEVALUES(state) {
      state.frontReady = false
      state.extraProcessingStatus2 = {}
      state.popupStatus = false
      document.body.classList.remove('ne-popup-open')
      state.activeProduct = null
      state.timerStartValue = null
      state.timerHideItems = []
      this.state.order.activeProducts = []
      this.state.order.activeProductsObject = {}
    }
  },
  actions: {
    // Old Editor
    setSocialButtonSectionKey({ commit }, value) {
      commit('SET_SOCIALBUTTONSECTIONKEY', value)
    },
    setButtonSectionKey({ commit }, value) {
      commit('SET_BUTTONSECTIONKEY', value)
    },
    setButtonId({ commit }, value) {
      commit('SET_BUTTONID', value)
    },
    setActiveShadowKey({ commit }, value) {
      commit('SET_ACTIVESHADOWKEY', value)
    },
    setHoverBoxKey({ commit }, value) {
      commit('SET_HOVERBOXKEY', value)
    },
    setActiveBoxKey({ commit }, value) {
      commit('SET_ACTIVEBOXKEY', value)
    },
    // New Editor
    setFrontReady({ commit }, value) {
      commit('SET_FRONTREADY', value)
    },
    setActiveObject({ commit }, value) {
      commit('SET_ACTIVEOBJECT', value)
    },
    setHoverObject({ commit }, value) {
      commit('SET_HOVEROBJECT', value)
    },
    setActiveEditorModal({ commit }, value) {
      commit('SET_ACTIVEEDITORMODAL', value)
    },
    setEditorStatus({ commit }, value) {
      commit('SET_EDITORSTATUS', value)
    },
    setResizeData({ commit }, value) {
      commit('SET_RESIZEDATA', value)
    },
    setListViewStatus({ commit }, value) {
      commit('SET_LISTVIEWSTATUS', value)
    },
    setImageUploadStatus2({ commit }, value) {
      commit('SET_IMAGEUPLOADSTATUS2', value)
    },
    setExtraProcessingStatus({ commit }, value) {
      commit('SET_EXTRAPROCESSINGSTATUS', value)
    },
    setExtraProcessingStatus2({ commit }, value) {
      commit('SET_EXTRAPROCESSINGSTATUS2', value)
    },
    setInstantGalleryUpdate({ commit }, value) {
      commit('SET_INSTANTGALLERYUPDATE', value)
    },
    setDevice({ commit }, value) {
      commit('SET_DEVICE', value)
    },
    setHideSettingsModal({ commit }, value) {
      commit('SET_HIDESETTINGS_MODAL', value)
    },
    setPopupStatus({ commit }, value) {
      commit('SET_POPUPSTATUS', value)
    },
    setIntegrationsObject({ commit }, value) {
      commit('SET_INTEGRATIONSOBJECT', value)
    },
    setPages({ commit }, value) {
      commit('SET_PAGES', value)
    },
    setFiles({ commit }, value) {
      commit('SET_FILES', value)
    },
    setBlocks({ commit }, value) {
      commit('SET_BLOCKS', value)
    },
    setAgencyBlocks({ commit }, value) {
      commit('SET_AGENCYBLOCKS', value)
    },
    setActiveProduct({ commit }, value) {
      commit('SET_ACTIVEPRODUCT', value)
    },
    setTimerStartValue({ commit }, value) {
      commit('SET_TIMERSTARTVALUE', value)
    },
    setTimerHideItems({ commit }, value) {
      commit('SET_TIMERHIDEITEMS', value)
    },
    initNewEditorValues({ commit }) {
      commit('INIT_NE_VALUES')
    },
    initNewEditorFEValues({ commit }) {
      commit('INIT_NE_FEVALUES')
    }
  },
  getters: {
    // Old Editor
    socialButtonSectionKey(state) { return state.socialButtonSectionKey },
    buttonSectionKey(state) { return state.buttonSectionKey },
    buttonId(state) { return state.buttonId },
    activeShadowKey(state) { return state.activeShadowKey },
    hoverBoxKey(state) { return state.hoverBoxKey },
    activeBoxKey(state) { return state.activeBoxKey },
    // New Editor
    frontReady(state) { return state.frontReady },
    activeObject(state) { return state.activeObject },
    hoverObject(state) { return state.hoverObject },
    activeEditorModal(state) { return state.activeEditorModal },
    editorStatus(state) { return state.editorStatus },
    resizeData(state) { return state.resizeData },
    listViewStatus(state) { return state.listViewStatus },
    imageUploadStatus2(state) { return state.imageUploadStatus2 },
    extraProcessingStatus(state) { return state.extraProcessingStatus },
    extraProcessingStatus2(state) { return state.extraProcessingStatus2 },
    instantGalleryUpdate(state) { return state.instantGalleryUpdate },
    device(state) { return state.device },
    hideSettingsModal(state) { return state.hideSettingsModal },
    popupStatus(state) { return state.popupStatus },
    integrationsObject(state) { return state.integrationsObject },
    pages(state) { return state.pages },
    files(state) { return state.files },
    blocks(state) { return state.blocks },
    agencyBlocks(state) { return state.agencyBlocks },
    activeProduct(state) { return state.activeProduct },
    timerStartValue(state) { return state.timerStartValue },
    timerHideItems(state) { return state.timerHideItems }
  }
}